export const VISIBILITY_OPERATORS = [
  'has_value', 'is_empty', 'is_true', 'is_false', 'equals', 'not_equals',
  'contains', 'not_contains', 'greater_than', 'greater_or_equal', 'less_than', 'less_or_equal',
];

export const operatorNeedsValue = (operator) =>
  !['has_value', 'is_empty', 'is_true', 'is_false'].includes(operator);

export const isNumericOperator = (operator) =>
  ['greater_than', 'greater_or_equal', 'less_than', 'less_or_equal'].includes(operator);

export const getValueType = (condition) => {
  if (isNumericOperator(condition.operator)) return 'number';
  if (['contains', 'not_contains'].includes(condition.operator)) return 'string';
  return condition.valueType || (typeof condition.value === 'number' ? 'number'
    : typeof condition.value === 'boolean' ? 'boolean' : 'string');
};

export const getConditionValue = (condition) => {
  const type = getValueType(condition);
  if (type === 'number') return Number(condition.value);
  if (type === 'boolean') return condition.value === true || condition.value === 'true';
  return String(condition.value ?? '');
};

export const hasFieldValue = (value) => value !== undefined && value !== null
  && (typeof value !== 'string' || value.trim() !== '')
  && (!Array.isArray(value) || value.length > 0);

export const matchesFieldCondition = (value, condition) => {
  const { operator } = condition;
  if (operator === 'has_value') return hasFieldValue(value);
  if (operator === 'is_empty') return !hasFieldValue(value);
  if (operator === 'is_true') return value === true || value === 'true';
  if (operator === 'is_false') return value === false || value === 'false';
  if (!hasFieldValue(value)) return false;
  const type = getValueType(condition);
  const expected = getConditionValue(condition);
  let actual = value;
  if (type === 'number') {
    if (typeof value === 'boolean' || !Number.isFinite(Number(value))) return false;
    actual = Number(value);
  } else if (type === 'boolean') {
    if (![true, false, 'true', 'false'].includes(value)) return false;
    actual = value === true || value === 'true';
  } else actual = String(value);
  switch (operator) {
    case 'equals': return actual === expected;
    case 'not_equals': return actual !== expected;
    case 'contains': return actual.includes(expected);
    case 'not_contains': return !actual.includes(expected);
    case 'greater_than': return actual > expected;
    case 'greater_or_equal': return actual >= expected;
    case 'less_than': return actual < expected;
    case 'less_or_equal': return actual <= expected;
    default: return false;
  }
};
